import { render, staticRenderFns } from "./AppUpload.vue?vue&type=template&id=f8904c6a&scoped=true"
import script from "./AppUpload.vue?vue&type=script&lang=js"
export * from "./AppUpload.vue?vue&type=script&lang=js"
import style0 from "./AppUpload.vue?vue&type=style&index=0&id=f8904c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8904c6a",
  null
  
)

export default component.exports